import { useTranslation } from "react-i18next";
import { TextInput } from "react-native-paper";
import DeleteFormActions from "./DeleteFormActions";

type Props = {
	handleDismiss: () => void;
	selectedReasons?: string;
	handleSetFeedback: (feedback: string) => void;
	feedback: string;
	handleShowDeleteConfirmation: () => void;
};

const DeleteFeedbackForm = ({
	handleDismiss,
	handleSetFeedback,
	selectedReasons,
	feedback,
	handleShowDeleteConfirmation,
}: Props) => {
	const { t } = useTranslation();

	const handleFormAction = (shouldDelete?: boolean) => {
		if (shouldDelete) {
			handleShowDeleteConfirmation();
		}
		handleDismiss();
	};

	const disabled = !selectedReasons;
	return (
		<>
			<TextInput
				placeholder={t("account.deleteFeedbackForm.placeholder")}
				mode="outlined"
				multiline
				onChangeText={handleSetFeedback}
				contentStyle={{
					minHeight: 120,
					maxHeight: 140,
				}}
				value={feedback}
			/>
			<DeleteFormActions
				handleAction={handleFormAction}
				disablePrimaryButton={disabled}
			/>
		</>
	);
};

export default DeleteFeedbackForm;
